import React, { useContext, useState, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import HeaderVariant from './HeaderVariant';
import HeaderControl from './HeaderControl';
import { StoreContext } from '../context/StoreContext';

const Header = props => {
  const {
    spaseekers: {
      site: { telephone },
      promotion: { theme: siteTheme, headerLabel },
    },
  } = useStaticQuery(graphql`
    query HeaderQuery {
      spaseekers {
        site {
          telephone
        }
        promotion {
          theme
          headerLabel {
            message
            linkText
            linkUrl
            countdown
            countdownDay
            countdownMonth
            countdownYear
          }
        }
      }
    }
  `);

  const testVariation = process.env.GATSBY_HOMEPAGE_TEST_VARIATION;

  const { cartItemCount } = useContext(StoreContext);

  const [daysUntilEvent, setDaysUntilEvent] = useState();

  const calculateDaysUntil = (year, month, day) => {
    const todaysDate = new Date();
    const cutOffDate = new Date(year, month, day);
    const difference = cutOffDate - todaysDate;
    let daysUntil = undefined;

    if (difference > 0) {
      daysUntil = Math.ceil(difference / (1000 * 60 * 60 * 24));
    }

    return daysUntil
      ? `${daysUntil} day${daysUntil > 1 ? 's' : ''} `
      : daysUntil;
  };

  useEffect(() => {
    if (!!headerLabel && headerLabel.countdownYear) {
      setDaysUntilEvent(
        calculateDaysUntil(
          headerLabel.countdownYear,
          headerLabel.countdownMonth - 1,
          headerLabel.countdownDay,
        ),
      );
    }
  }, [headerLabel]);

  const hasHeaderLabel =
    headerLabel && (!!headerLabel.message || headerLabel.countdown);

  return testVariation === 'variant' ? (
    <HeaderVariant
      telephone={telephone}
      cartItemCount={cartItemCount}
      hasHeaderLabel={hasHeaderLabel}
      headerLabel={headerLabel}
      siteTheme={siteTheme}
      daysUntilEvent={daysUntilEvent}
      {...props}
    />
  ) : (
    <HeaderControl
      telephone={telephone}
      cartItemCount={cartItemCount}
      hasHeaderLabel={hasHeaderLabel}
      headerLabel={headerLabel}
      siteTheme={siteTheme}
      daysUntilEvent={daysUntilEvent}
      {...props}
    />
  );
};

export default Header;
